import React, { useEffect } from "react";
import { Subtitle2, mergeClasses, tokens, Body1 } from "@fluentui/react-components";
import { useStyles } from "./OrderStatusStyles";
import { Receipt24Filled } from "@fluentui/react-icons";
import { HelperUtils, appInsightsEvents, trackEvent, useAppStore } from "../../../common";
import { Order, OrderStatus } from "@dining/api-client";
import { OrderTimelineCard } from "./OrderTimeLineCard";
import { OrderStatusProblemCard } from "./OrderStatusProblemCard";

interface OrderStatusProps {
  order?: Order;
}

export const OrderStatusCard = ({ order }: OrderStatusProps) => {
  const styles = useStyles();
  const context = useAppStore((state) => state.context);
  const appInsights = useAppStore((state) => state.appInsights);

  const helperUtils = HelperUtils.getInstance();

  useEffect(() => {
    trackEvent(appInsights, appInsightsEvents.Usage.ViewComponent, context, {
      componentName: "OrderStatusCard",
    });
  }, [context, appInsights]);

  return (
    order &&
    (order.status === OrderStatus.CannotFulfill ? (
      <OrderStatusProblemCard order={order} />
    ) : (
      <div className={styles.container} data-testid="OrderStatusCard">
        <Subtitle2 className={styles.subTitle}>
          Order #{helperUtils.getLastThreeDigitsOfNum(order.orderNumber)}
        </Subtitle2>
        <Body1 className={styles.orderDate}>
          {helperUtils.getDateFromTimestamp(order.timeStamp)}
        </Body1>
        <div className={styles.orderContainer}>
          <div className={styles.orderNumberContainer}>
            <div className={styles.orderRightSection}>
              <div className={styles.orderIconSection}>
                <Receipt24Filled
                  className={styles.icon}
                  primaryFill={tokens.colorNeutralBackground1}
                />
              </div>

              <Subtitle2
                wrap={false}
                truncate
                className={mergeClasses(styles.orderNumberSection, styles.text, styles.white)}
                tabIndex={0}
                aria-label={`Order ${helperUtils.getLastThreeDigitsOfNum(order.orderNumber)}`}
              >
                Order #{helperUtils.getLastThreeDigitsOfNum(order.orderNumber)}
              </Subtitle2>
            </div>
          </div>
          <div className={styles.orderStatusContainer}>
            <div className={styles.centered}>
              <OrderTimelineCard order={order} />
            </div>
          </div>
          <div className={styles.pickupLocationContainer}>
            <div className={styles.orderRightSection}>
              <Subtitle2 wrap={false} truncate className={mergeClasses(styles.text, styles.purple)}>
                Order location
              </Subtitle2>
              <br />
              <Subtitle2 wrap={true} className={mergeClasses(styles.regular, styles.text)}>
                {helperUtils.getOrderPickupCafeStationsString(order)}
              </Subtitle2>
            </div>
          </div>
        </div>
      </div>
    ))
  );
};
